import { networkSignal } from "@/utils/signals";
import { Course } from "@/api";
import { initApi } from "@/utils";

const courses = networkSignal<Course[]>({ default: [] });

export type UseCoursesStore = ReturnType<typeof useCourses>;

export function useCourses() {
  const fetch = async () => {
    await courses.run(getCourses);
  };

  return { ...courses.signal, fetch, getCourseTitle: getCourseTitleSelector, getCourseWithId: getCourseWithIdSelector };
}

async function getCourses(): Promise<Course[]> {
  const api = initApi();
  return await api.getCourses();
}

function getCourseTitleSelector(course: Course): string {
  return course.metadata?.title || course.id || "";
}

function getCourseWithIdSelector(id: string): Course | undefined {
  return courses.signal.data.value?.find(c => c.id === id);
}
